import {
    draw_tab as Strings_draw_tab,
    format_picture_tab as Strings_format_picture_tab,
    format_tab as Strings_format_tab,
    format_table_tab as Strings_format_table_tab,
    insert_tab as Strings_insert_tab,
    mail_merge_tab as Strings_mail_merge_tab,
    message_tab as Strings_message_tab,
    options_tab as Strings_options_tab,
} from 'owa-locstrings/lib/strings/ribbon_mail_buttons_and_tabs.locstring.json';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { ResourceId } from 'owa-localize';
import type { MailboxInfo } from 'owa-client-types';

export function getComposeTabs(_mailboxInfo: MailboxInfo): MailRibbonTabId[] {
    return [10, 5, 4, 12, 11];
}

export const MailRibbonTabTitleMap: Map<MailRibbonTabId, ResourceId> = new Map<
    MailRibbonTabId,
    ResourceId
>([
    [4, Strings_format_tab],
    [5, Strings_insert_tab],
    [15, Strings_mail_merge_tab],
    [10, Strings_message_tab],
    [11, Strings_options_tab],
    [7, Strings_format_table_tab],
    [12, Strings_draw_tab],
    [13, Strings_format_picture_tab],
]);
